// extracted by mini-css-extract-plugin
export default {"starterScreen":"xm","starterImage":"ym","already":"zm","starterImageMobile":"Am","controlX":"Bm","starterTextContain":"Cm","starterHeader":"Em","starterBtn":"Fm","starterSecondaryBtn":"Gm","starterBanner":"Hm","mobileBtnContainer":"Im"};
    if(module.hot) {
      // 1715091668854
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  